module.exports = __webpack_public_path__ + "img/venus16.9708e412.png";